// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".excellent-capabilities .excellent-capabilities-instructions[data-v-134811e2],.excellent-capabilities .excellent-capabilities-introduce[data-v-134811e2]{margin-bottom:var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
